// Central benchmark investment assumptions with attributed public sources.
// Update this file (values + `lastUpdated`) to refresh comparisons site-wide.
// Do NOT hardcode inside components — always read from here.

export const BENCHMARKS = {
  fd: {
    key: 'fd',
    label: 'Fixed Deposits',
    defaultReturnPct: 7.1,
    source: 'RBI · Scheduled Commercial Bank average FD rate (1–3 yr)',
    sourceUrl: 'https://www.rbi.org.in/scripts/PublicationsView.aspx?id=22787',
    publicationDate: '2025-11',
    lastUpdated: '2026-02-22',
  },
  mf: {
    key: 'mf',
    label: 'Mutual Funds',
    defaultReturnPct: 12.5,
    source: 'AMFI · 10-year category CAGR (Diversified Equity)',
    sourceUrl: 'https://www.amfiindia.com/research-information/other-data/scheme-returns',
    publicationDate: '2025-12',
    lastUpdated: '2026-02-22',
  },
  rental: {
    key: 'rental',
    label: 'Residential Rental Property',
    defaultReturnPct: 3.2,
    source: 'ANAROCK · Residential Rental Yield Report, Top 7 Cities',
    sourceUrl: 'https://www.anarock.com/research-report',
    publicationDate: '2025-10',
    lastUpdated: '2026-02-22',
  },
};

export const BENCHMARK_ORDER = ['rental', 'fd', 'mf'];
